module.exports = [
  { id: '54', abbreviation: 'AB', value: 'Alberta' },
  { id: '55', abbreviation: 'BC', value: 'British Columbia' },
  { id: '56', abbreviation: 'MB', value: 'Manitoba' },
  { id: '57', abbreviation: 'NB', value: 'New Brunswick' },
  { id: '58', abbreviation: 'NL', value: 'Newfoundland and Labrador' },
  { id: '59', abbreviation: 'NT', value: 'Northwest Territories' },
  { id: '60', abbreviation: 'NS', value: 'Nova Scotia' },
  { id: '61', abbreviation: 'NU', value: 'Nunavut' },
  { id: '62', abbreviation: 'ON', value: 'Ontario' },
  { id: '63', abbreviation: 'PE', value: 'Prince Edward Island' },
  { id: '111', abbreviation: 'QC', value: 'Quebec' },
  { id: '112', abbreviation: 'SK', value: 'Saskatchewan' },
  { id: '113', abbreviation: 'YT', value: 'Yukon' },
];
